import MasterApiBase from "./master-api.base";

const STAMP_ENDPOINT = "/stamp";
const STAMP_CSV_ENDPOINT = "/csv";

export default class StampApi extends MasterApiBase {
	create = (data) => {
		return this.axios.post(`${STAMP_ENDPOINT}`, data, {
			headers: {
				"Content-Type": "multipart/form-data",
			},
		});
	};

	getDetail = async () => {
		return await this.axios.get(STAMP_ENDPOINT);
	};

	reset = async () => {
		return await this.axios.delete(STAMP_ENDPOINT);
	};

	downloadCSV = async () => {
		return await this.axios.get(STAMP_CSV_ENDPOINT);
	};
}
